export const PHONE_NUMBER_PREFIX_UZB = "998";
export const PHONE_NUMBER_PREFIX_UZB_PLUS = "+998";
